import { useParams } from 'react-router-dom';
import { decryptURL } from 'utils/functions';
import Amazon from './Amazon';
import MadeiraMadeira from './MadeiraMadeira';
import Magalu from './Magalu';
import MercadoLivre from './MercadoLivre';
import Shein from './Shein';
import Shopee from './Shopee';
import Tiktok from './Tiktok';

const Editar = () => {
  const { hash } = useParams();
  const decrypt = decryptURL(hash);

  const props = {};

  switch (decrypt?.marketplace) {
    case 'AMAZON':
      return <Amazon {...props} />;
    case 'MADEIRA MADEIRA':
      return <MadeiraMadeira {...props} />;
    case 'MAGAZINE LUIZA':
      return <Magalu {...props} />;
    case 'MERCADO LIVRE':
      return <MercadoLivre {...props} />;
    case 'SHEIN':
      return <Shein {...props} />;
    case 'SHOPEE':
      return <Shopee {...props} />;
    case 'TIKTOK':
      return <Tiktok {...props} />;
    default:
      return null;
  }
};

export default Editar;
